import React from 'react';

import { Drawer, Table } from 'antd';
import moment from "moment";

const tableDefinition = {
	// 滚动设置
	scroll: { x: 800, y: window.innerHeight - 370 },
	// 表格列
	columns: [
		{
			title: "客户sap编码",
			dataIndex: "sap_no",
			key: "sap_no",
		}, {
			title: "续授信申请编号",
			dataIndex: "apply_no",
			key: "apply_no",
		}, {
			title: "授信类型",
			dataIndex: "credit_type",
			key: "credit_type",
		}, {
			title: "审核意见",
			dataIndex: "audit_opinion",
			key: "audit_opinion",
		}, {
			title: "审核结果",
			dataIndex: "audit_result",
			key: "audit_result",
			render: audit_result => {
				if (!audit_result) return null;

				let text = "";
				let color = "";

				switch (audit_result) {
					case "01":
						text = "成功";
						color = "green"; // 默认黑色或其他颜色
						break;
					case "02":
						text = "失败";
						color = "red";
						break;
					case "03":
						text = "退回补件";
						color = "red";
						break;
					default:
						text = audit_result;
						color = ""; // 默认颜色
				}

				return <span style={{ color }}>{text}</span>;
			}
		}
		, {
			title: "审核时间",
			dataIndex: "audit_time",
			key: "audit_time",
			render: time => (time && moment(time).format("YYYY-MM-DD HH:mm")),
		}, {
			title: "最新额度（单位为分）",
			dataIndex: "credit_amount",
			key: "credit_amount",
			width: 200,
		}, {
			title: "社会信用代码",
			dataIndex: "social_credit_code",
			key: "social_credit_code",
		}
	]
}

const ClientCreditDrawer = (props) => {

	const { onClose, visible, value } = props

	// 是否有授信记录
	const hasCreditRecord = value && value.length > 0;
	// 有授信记录宽度较大，显示授信信息，否则显示小一些的未查询到授信信息
	const width = hasCreditRecord ? window.innerWidth * 0.75 : window.innerWidth * 0.25;

	return (

		<Drawer title={<span>客户授信信息</span>} placement="right" closable={false} onClose={onClose} visible={visible} width={width} >
			{
				hasCreditRecord ? (
					<Table {...tableDefinition} dataSource={value}>
					</Table>
				) : "未查询到授信信息"
			}

		</Drawer>

	)

}


export default ClientCreditDrawer;
